import { render, staticRenderFns } from "./EntryForm.vue?vue&type=template&id=2891f852&scoped=true"
import script from "./EntryForm.vue?vue&type=script&lang=js"
export * from "./EntryForm.vue?vue&type=script&lang=js"
import style0 from "./EntryForm.vue?vue&type=style&index=0&id=2891f852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891f852",
  null
  
)

export default component.exports